@switch (step()) {
    @case ("keyNumber") {
        <app-iackathon-step-key-number [save]="save()"></app-iackathon-step-key-number>
    }
    @case ("problematic") {
        <app-iackathon-step-problematic [save]="save()"></app-iackathon-step-problematic>
    }
    @case ("howNowWow") {
        <app-iackathon-step-how-now-wow [save]="save()"></app-iackathon-step-how-now-wow>
    }
    @case ("finalIdea") {
        <app-iackathon-step-final-idea [save]="save()"></app-iackathon-step-final-idea>
    }
    @case ("canvas") {
        <app-iackathon-step-canvas [save]="save()"></app-iackathon-step-canvas>
    }
    @case ("deliverable") {
        <app-iackathon-step-deliverable [save]="save()"></app-iackathon-step-deliverable>
    }
    @case ("ratingOthers") {
        <app-iackathon-step-rating-others [save]="save()"></app-iackathon-step-rating-others>
    }
    @case ("rate") {
        <app-iackathon-step-rate [save]="save()"></app-iackathon-step-rate>
    }
}